import { IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DonutChart } from '@charts';
import { useResolvedCssColor } from '@charts/helpers';

// `summary.salesTotal` is the paid-charge COUNT — the only currency-safe figure to
// put on one chart (BRL and USD amounts must never share a scale). So the split is
// national vs international by number of sales, not by value.
function salesCount(report, currency) {
    const bucket = report?.currencyReports?.find(r => r.currency === currency);
    return Number(bucket?.summary?.salesTotal) || 0;
}

export default function SalesSplitCard({ report, reportLoading }) {
    const { t } = useTranslation('dashboard');
    const nationalColor = useResolvedCssColor('--chart-1');
    const internationalColor = useResolvedCssColor('--chart-7');

    const slices = [
        { id: 'national', label: t('insights.charts.salesSplitNational'), value: salesCount(report, 'BRL'), color: nationalColor },
        { id: 'international', label: t('insights.charts.salesSplitInternational'), value: salesCount(report, 'USD'), color: internationalColor },
    ];

    return (
        <DonutChart
            title={t('insights.charts.salesSplitTitle')}
            icon={<IconWorld size={15} />}
            slices={slices}
            valueType="number"
            unitSingular={t('insights.charts.unitSaleSingular')}
            unitPlural={t('insights.charts.unitSalePlural')}
            centerLabel={t('insights.charts.salesSplitCenter')}
            emptyMessage={t('insights.charts.salesSplitEmpty')}
            report={report}
            reportLoading={reportLoading}
            cornerRadius="large"
        />
    );
}
